module.exports = __webpack_public_path__ + "static/media/crisps.c5c22dcd.png";